<template>
  <div class="mod-config">
    <el-card class="box-card">
      <div slot="header" class="card-header">
        <h3>{{ $t('vipPurchase.title') }}</h3>
      </div>
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="110px">
        <!-- 用户账号输入 -->
        <el-form-item :label="$t('vipPurchase.userAccount')" prop="zhanghao">
          <el-row type="flex" align="middle">
            <el-col :span="16">
              <el-input v-model="dataForm.zhanghao" :placeholder="$t('vipPurchase.inputUserAccount')"></el-input>
            </el-col>
            <el-col :span="7" :offset="1">
              <el-button type="primary" @click="searchUser">{{ $t('vipPurchase.searchUser') }}</el-button>
            </el-col>
          </el-row>
        </el-form-item>

        <!-- 用户信息展示区域 -->
        <el-form-item v-if="userData" :label="$t('vipPurchase.userInfo')">
          <div class="user-info">
            <p><strong>{{ $t('vipPurchase.name') }}:</strong> {{ userData.zhanghao || $t('vipPurchase.notSet') }}</p>
            <p><strong>{{ $t('vipPurchase.balance') }}:</strong> {{ userData.yue }} {{ $t('common.yuan') }}</p>
            <p v-if="userData.vipLevel"><strong>{{ $t('vipPurchase.currentVipLevel') }}:</strong> {{ userData.vipLevel }}</p>
            <p v-if="userData.vipExpiry"><strong>{{ $t('vipPurchase.vipExpiry') }}:</strong> {{ formatDate(userData.vipExpiry) }}</p>
          </div>
        </el-form-item>

        <!-- VIP规则选择 -->
        <el-form-item :label="$t('vipPurchase.vipRule')" prop="ruleId">
          <el-select v-model="dataForm.ruleId" :placeholder="$t('vipPurchase.selectVipRule')" @change="handleRuleChange">
            <el-option 
              v-for="item in vipRules" 
              :key="item.id" 
              :label="`${item.viplevel} (${item.discount}${$t('vipPurchase.discountUnit')} - ${item.duration}${$t('vipPurchase.monthUnit')})`" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- VIP等级信息 -->
        <el-form-item v-if="selectedRule" :label="$t('vipPurchase.vipLevel')">
          <span>{{ selectedRule.viplevel }}</span>
        </el-form-item>

        <!-- 有效期 -->
        <el-form-item v-if="selectedRule" :label="$t('vipPurchase.validityPeriod')">
          <span>{{ selectedRule.duration }} {{ $t('vipPurchase.monthUnit') }}</span>
        </el-form-item>

        <!-- 售价 -->
        <el-form-item v-if="selectedRule" :label="$t('vipPurchase.price')">
          <span>{{ selectedRule.amount }} {{ $t('common.yuan') }}</span>
        </el-form-item>

        <!-- 支付方式选择 -->
        <payment-methods 
          v-model="dataForm.paymentMethod" 
          :isMember="userData !== null"
          @change="handlePaymentMethodChange">
        </payment-methods>

        <!-- 打印设置 -->
        <el-form-item :label="$t('vipPurchase.receiptSettings')">
          <el-switch
            v-model="printSettings.autoPrint"
            :active-text="$t('vipPurchase.autoPrintReceipt')"
            :inactive-text="$t('vipPurchase.manualPrintReceipt')">
          </el-switch>
          <el-select 
            v-if="printSettings.autoPrint" 
            v-model="printSettings.printerName" 
            :placeholder="$t('vipPurchase.selectPrinter')" 
            style="margin-left: 20px;"
            size="small">
            <el-option
              v-for="printer in printers"
              :key="printer.name"
              :label="printer.name"
              :value="printer.name">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitForm('dataForm')" :disabled="submitLoading">{{ $t('vipPurchase.confirmPurchase') }}</el-button>
          <el-button @click="resetForm('dataForm')">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import PaymentMethods from '@/components/common/PaymentMethods'
import ReceiptAction from '@/components/common/ReceiptAction'
import printService from '@/utils/printService'

export default {
  components: {
    PaymentMethods,
    ReceiptAction
  },
  data() {
    return {
      dataForm: {
        zhanghao: '',
        ruleId: '',
        paymentMethod: 1 // 默认现金支付
      },
      dataRule: {
        zhanghao: [
          { required: true, message: this.$t('vipPurchase.userAccountRequired'), trigger: 'blur' }
        ],
        ruleId: [
          { required: true, message: this.$t('vipPurchase.selectVipRuleRequired'), trigger: 'change' }
        ]
      },
      userData: null,
      vipRules: [],
      selectedRule: null,
      submitLoading: false,
      // 打印设置
      printSettings: {
        autoPrint: true,
        printerName: ''
      },
      // 可用打印机列表
      printers: [
        { name: 'HP LaserJet (默认)' },
        { name: '收据打印机' },
        { name: 'Epson TM-T88V' }
      ],
      // 支付结果
      paymentResult: null
    }
  },
  created() {
    this.getVipRules();
    // 从URL参数获取用户账号
    const zhanghao = this.$route.query.zhanghao;
    if (zhanghao) {
      this.dataForm.zhanghao = zhanghao;
      this.searchUser();
    }
  },
  methods: {
    // 获取VIP规则列表
    getVipRules() {
      this.$http({
        url: '/viprule/list',
        method: 'get',
        params: {
          page: 1,
          limit: 100
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.vipRules = data.page.list;
        }
      });
    },
    
    // 查找用户
    searchUser() {
      if (!this.dataForm.zhanghao) {
        this.$message.warning('请输入用户账号');
        return;
      }
      const encodedZhanghao = encodeURIComponent(this.dataForm.zhanghao);
      const url = `/yonghu/checkUsername?zhanghao=${encodedZhanghao}`;
      
      this.$http({
        url: url,
        method: 'get'
      }).then(({ data }) => {
        console.log('查询用户结果:', data);
        
        if (data && data.code === 0) {
          this.userData = data.user;
          this.$message.success('用户查询成功');
        } else {
          this.$message.error(data.msg || '用户不存在');
          this.userData = null;
        }
      }).catch((error) => {
        console.error('查询用户请求失败:', error);
        this.$message.error('查询用户失败');
      });
    },
    
    // 处理VIP规则变更
    handleRuleChange(ruleId) {
      this.selectedRule = this.vipRules.find(rule => rule.id === ruleId);
    },
    
    // 处理支付方式变更
    handlePaymentMethodChange(method) {
      // 如果选择会员余额，检查余额是否足够
      if (method === 2 && this.userData) {
        if (this.selectedRule && parseFloat(this.userData.yue) < parseFloat(this.selectedRule.amount)) {
          this.$message.warning(this.$t('vipPurchase.insufficientBalance'));
          this.dataForm.paymentMethod = 1; // 重置为现金支付
        }
      }
    },
    
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.userData) {
            this.$message.warning(this.$t('vipPurchase.pleaseSearchUser'));
            return;
          }
          
          if (!this.selectedRule) {
            this.$message.warning(this.$t('vipPurchase.pleaseSelectVipRule'));
            return;
          }
          
          // 检查会员余额支付
          if (this.dataForm.paymentMethod === 2) {
            if (parseFloat(this.userData.yue) < parseFloat(this.selectedRule.amount)) {
              this.$message.error(this.$t('vipPurchase.userBalanceInsufficient'));
              return;
            }
          }
          
          this.$confirm(this.$t('vipPurchase.confirmPurchaseForUser') + ' ' + this.dataForm.zhanghao + ' ' + this.$t('vipPurchase.purchase') + ' ' + this.selectedRule.viplevel + ' VIP?', this.$t('common.tip'), {
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }).then(() => {
            this.submitLoading = true;
            
            // 构建请求参数
            const params = new URLSearchParams();
            params.append('zhanghao', this.dataForm.zhanghao);
            params.append('vipLevel', this.selectedRule.viplevel);
            params.append('duration', this.selectedRule.duration);
            params.append('amount', this.selectedRule.amount);
            params.append('paymentMethod', this.dataForm.paymentMethod);
            
            this.$http({
              url: '/yonghu/purchaseVip',
              method: 'post',
              params: params
            }).then(({ data }) => {
              this.submitLoading = false;
              if (data && data.code === 0) {
                // 保存支付结果
                this.paymentResult = {
                  id: data.orderId || new Date().getTime(),
                  customerName: this.userData.xingming,
                  zhanghao: this.userData.zhanghao,
                  vipLevel: this.selectedRule.viplevel,
                  duration: this.selectedRule.duration,
                  amount: this.selectedRule.amount,
                  paymentMethod: this.dataForm.paymentMethod,
                  // operatorName: this.$store.getters.user.username || '管理员',
                  operatorName: '管理员',
                  vipExpiry: data.vipExpiry
                };
                
                // 是否自动打印
                if (this.printSettings.autoPrint) {
                  this.printReceipt();
                }
                
                // 显示收据操作对话框
                this.$confirm(this.$t('vipPurchase.askSendReceipt'), this.$t('vipPurchase.purchaseSuccess'), {
                  confirmButtonText: this.$t('vipPurchase.sendReceiptEmail'),
                  cancelButtonText: this.$t('common.close'),
                  distinguishCancelAndClose: true,
                  type: 'success'
                }).then(() => {
                  // 发送邮件收据
                  this.sendReceiptByEmail();
                }).catch(action => {
                  if (action === 'cancel') {
                    // 用户点击关闭，重置表单
                    this.resetForm(formName);
                  }
                });
              } else {
                this.$message.error(data.msg || this.$t('vipPurchase.purchaseFailed'));
              }
            }).catch(() => {
              this.submitLoading = false;
              this.$message.error(this.$t('vipPurchase.operationFailed'));
            });
          });
        }
      });
    },
    
    // 打印收据
    printReceipt() {
      if (!this.paymentResult) return;
      
      try {
        // 调用打印服务
        printService.printReceipt(this.paymentResult, 'vip');
      } catch (error) {
        console.error(this.$t('vipPurchase.printFailed') + ':', error);
        this.$message.error(this.$t('vipPurchase.printReceiptFailed') + error.message);
      }
    },
    
    // 发送邮件收据
    sendReceiptByEmail() {
      if (!this.paymentResult) return;
      
      // 准备邮件地址
      let email = '';
      if (this.userData?.zhanghao) {
        // 这里假设使用会员账号作为邮箱前缀
        email = `${this.userData.zhanghao}@example.com`;
      }
      
      // 显示邮件对话框
      this.$prompt(this.$t('vipPurchase.enterEmail'), this.$t('vipPurchase.sendReceipt'), {
        confirmButtonText: this.$t('vipPurchase.send'),
        cancelButtonText: this.$t('common.cancel'),
        inputValue: email,
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: this.$t('vipPurchase.invalidEmail')
      }).then(({ value }) => {
        // 调用服务发送邮件
        printService.sendReceiptByEmail(this.paymentResult, 'vip', value)
          .then(response => {
            if (response.code === 0) {
              this.$message.success(this.$t('vipPurchase.receiptSentTo') + value);
              this.resetForm('dataForm');
            } else {
              this.$message.error(this.$t('vipPurchase.sendEmailFailed') + response.msg);
            }
          })
          .catch(error => {
            this.$message.error(this.$t('vipPurchase.sendEmailFailed') + error.message);
          });
      }).catch(() => {
        // 用户取消，重置表单
        this.resetForm('dataForm');
      });
    },
    
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.userData = null;
      this.selectedRule = null;
      this.paymentResult = null;
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleString();
    }
  }
}
</script>

<style scoped>
.mod-config {
  padding: 20px;
}
.box-card {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-info {
  background-color: #f8f8f8;
  padding: 15px;
  border-radius: 4px;
  border-left: 4px solid #409EFF;
}
</style> 